import { html as o } from "@microsoft/fast-element";
const l = o`
  <a
    class="control"
    part="control"
    href="${(t) => t.href}"
    target="${(t) => t.target}"
  >
    <slot></slot>
  </a>
`;
export {
  l as linkTemplate
};
